import Vue from 'vue'
import VueRouter from 'vue-router'
//import {docsRouters, docsMenu, docsMenuRouters} from './docs/router'
import getMenuRoute from './pages/router'
import {common} from '@/untils'
import NProgress from 'nprogress'

Vue.use(VueRouter)


var router = new VueRouter({
  routes: [
    {path: '/', redirect: '/index'},
    {path: '/index', component: resolve => require(['@/pages/index'], resolve)},
    //...docsRouters,
    ...getMenuRoute()
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
  common.scrollTop()
})

export const addMenuRoute = function(user) {
  router.addRoutes(getMenuRoute(user))
}

export default router

// export {
//   docsMenu,
//   docsMenuRouters
// }



// WEBPACK FOOTER //
// ./src/router/index.js